<template>
  <div
      class="nx-image"
      :class="{ landscape, portrait: !landscape, loaded }"
      :style="dynamicStyles"
  >
    <img
        :alt="alt"
        :src="src"
        @error="loadFailed"
        @load="imageLoaded"
        ref="image"
        v-if="src && !error"
    >

    <v-icon v-html="placeholderIcon" v-else-if="!error"></v-icon>
    <v-icon v-html="errorIcon" v-else></v-icon>

  </div>
</template>

<script>
export default {
  name: 'nx-image',
  extends: {},
  mixins: [],
  components: {},
  props: {
    src: {
      type: String,
      validator: value => !!value, /* Check for empty strings */
    },
    alt: {
      type: String,
      default: '',
    },
    width: [Number, String],
    height: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    placeholderIcon: {
      type: String,
      default: 'photo',
    },
    errorIcon: {
      type: String,
      default: 'broken_image',
    },
    top: Boolean,
    bottom: Boolean,
    right: Boolean,
    left: Boolean,
  },
  data() {
    return {
      landscape: true,
      loaded: false,
      error: false,
    };
  },
  computed: {
    dynamicStyles() {
      const styles = {};
      if (this.height) styles.height = this.parseProperty(this.height);
      if (this.maxHeight) styles.maxHeight = this.parseProperty(this.maxHeight);
      if (this.maxWidth) styles.maxWidth = this.parseProperty(this.maxWidth);
      if (this.width) styles.width = this.parseProperty(this.width);
      if (this.minHeight) styles.minHeight = this.parseProperty(this.minHeight);
      if (this.minWidth) styles.minWidth = this.parseProperty(this.minWidth);
      if (this.top) styles.justifyContent = 'flex-start';
      if (this.bottom) styles.justifyContent = 'flex-end';
      if (this.right) styles.alignItems = 'flex-start';
      if (this.left) styles.alignItems = 'flex-end';
      return styles;
    },
  },
  watch: {
    src() {
      this.loaded = false;
      this.error = false;
    },
  },
  methods: {
    imageLoaded() {
      if (this.$refs.image) {
        const { width, height } = this.$refs.image;
        this.landscape = width >= height;
      }
      this.loaded = true;
      this.error = false;
      this.$emit('load', this.$refs.image);
    },
    loadFailed() {
      this.error = true;
      this.$emit('error', this.$refs.image);
    },
    parseProperty(prop) {
      const [, number, unit] = /(\d+)(.*)/.exec(prop);
      return `${number}${unit || 'px'}`;
    },
  },
};
</script>

<style lang="stylus">
.nx-image {

  display: flex;
  flex-direction: column;
  justify-content: center; // Centering y-axis
  align-items: center; //Centering x-axis
  height: 100%

  img {
    opacity: 0
    transition: opacity 0.3s
    max-width: 100%
    max-height: 100%
  }
  &.loaded img {
    opacity: 1
  }

  &.landscape {
    img {
      max-width: 100%
    }
  }

  &.portrait {
    img {
      max-height: 100%
    }
  }

}
</style>
